var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pb-1" },
    [
      _c(
        "b-card",
        { staticClass: "mb-2" },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "5" } },
                [
                  _c("e-store-combo", {
                    attrs: {
                      id: "auto-delivery-monitor_stores",
                      multiple: true,
                      required: false,
                      "select-single-option": false,
                      label: _vm.$t("Lojas"),
                      placeholder: _vm.$t("Todas as lojas"),
                    },
                    model: {
                      value: _vm.storeIds,
                      callback: function ($$v) {
                        _vm.storeIds = $$v
                      },
                      expression: "storeIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "auto-delivery-monitor_period-preset",
                      type: "vue-select",
                      label: _vm.$t("Período"),
                      clearable: false,
                      options: _vm.periodOptions,
                    },
                    model: {
                      value: _vm.periodPreset,
                      callback: function ($$v) {
                        _vm.periodPreset = $$v
                      },
                      expression: "periodPreset",
                    },
                  }),
                ],
                1
              ),
              _vm.periodPreset === _vm.periodPresets.CUSTOM
                ? _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "auto-delivery-monitor_period-range",
                          type: "date-range-picker",
                          label: _vm.$t("Datas"),
                        },
                        model: {
                          value: _vm.rangeDate,
                          callback: function ($$v) {
                            _vm.rangeDate = $$v
                          },
                          expression: "rangeDate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-between flex-wrap",
            },
            [
              _c("small", { staticClass: "text-muted" }, [
                _vm._v(" " + _vm._s(_vm.lastUpdatedLabel) + " "),
                _vm.autoRefreshPaused
                  ? _c("span", [
                      _vm._v(
                        " · " +
                          _vm._s(
                            _vm.$t(
                              "atualização automática pausada (aba em segundo plano)"
                            )
                          )
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("e-button", {
                attrs: {
                  id: "auto-delivery-monitor_refresh",
                  icon: "arrow-clockwise",
                  busy: _vm.fetching,
                  text: _vm.$t("Atualizar"),
                },
                on: { click: _vm.refresh },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("monitor-health", {
        attrs: {
          health: _vm.health,
          "selected-alert": _vm.alertFilter && _vm.alertFilter.alert,
        },
        on: { select: _vm.selectAlert },
      }),
      _c(
        "b-alert",
        {
          attrs: {
            show: !!(_vm.overview && _vm.overview.truncated),
            variant: "warning",
          },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t(
                  "O período tem mais vendas do que o painel exibe. Mostrando as mais recentes:"
                )
              ) +
              " " +
              _vm._s(_vm.overview && _vm.overview.maxSales) +
              ". " +
              _vm._s(_vm.$t("Restrinja o período ou as lojas.")) +
              " "
          ),
        ]
      ),
      _c("monitor-summary", { attrs: { summary: _vm.summary } }),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            {
              attrs: { card: "" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("Vendas") + " (" + _vm.sales.length + ")",
                  },
                },
                [
                  _c("monitor-sales-table", {
                    attrs: {
                      sales: _vm.sales,
                      "alert-filter": _vm.alertFilter,
                    },
                    on: {
                      open: _vm.openSale,
                      "clear-alert": function ($event) {
                        _vm.alertFilter = null
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("Por loja") + " (" + _vm.stores.length + ")",
                  },
                },
                [
                  _c("monitor-stores-table", {
                    attrs: { stores: _vm.stores },
                    on: { "select-store": _vm.selectStore },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("monitor-sale-sidebar", {
        attrs: { "sale-id": _vm.openedSaleId },
        on: {
          hidden: function ($event) {
            _vm.openedSaleId = null
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }